import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getUsersService = (request?: t.GetUsersRequestType) => {
  const GET_USERS_API_ENDPOINT = `${apiCoreEndpoint}/user`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_USERS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_USERS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addUserService = (request: t.CreateUserRequestType) => {
  log.info("addUserService Request: " + JSON.stringify(request));
  const ADD_USER_API_ENDPOINT = `${apiCoreEndpoint}/user`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const modifyUserService = (request: t.ModifyUserRequestType) => {
  log.info("modifyUserService Request: " + JSON.stringify(request));
  const userId = request.id;
  const MODIFY_USER_API_ENDPOINT = `${apiCoreEndpoint}/user/${userId}`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(MODIFY_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, MODIFY_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteUserService = (request: t.DeleteUserRequestType) => {
  log.info("deleteUserService Request: " + JSON.stringify(request));
  const userId = request.id;
  const DELETE_USER_API_ENDPOINT = `${apiCoreEndpoint}/user/${userId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getCurrentUserService = (
  request?: t.GetCurrentUserRequestType
) => {
  const GET_CURRENT_USER_API_ENDPOINT = `${apiCoreEndpoint}/current-user`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_CURRENT_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_CURRENT_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const changePasswordCurrentUserService = (
  request: t.CurrentUserChangePasswordRequestType
) => {
  log.info(
    "changePasswordCurrentUserService Request: " + JSON.stringify(request)
  );
  const CHANGE_PASSWORD_CURRENT_USER_API_ENDPOINT = `${apiCoreEndpoint}/current-user/change-password`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(CHANGE_PASSWORD_CURRENT_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(
        response,
        CHANGE_PASSWORD_CURRENT_USER_API_ENDPOINT
      );
    })
    .then((json) => {
      return json;
    });
};
